import Cookies from 'js-cookie';

import { APP_ORIGIN_COOKIE_NAME, APP_ORIGIN_COOKIE_VALUE } from 'types';

export const ensureAppOriginCookie = (): void => {
  if (typeof document === 'undefined') return;
  if (Cookies.get(APP_ORIGIN_COOKIE_NAME)) return;

  Cookies.set(APP_ORIGIN_COOKIE_NAME, APP_ORIGIN_COOKIE_VALUE, {
    secure: true,
    sameSite: 'lax',
    expires: 30, // expires in 30 days
  });
};
